import { useEffect, useState } from "react";
import { Check, Pencil, Trash2, UserRound, X } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { SchoolOrderButton } from "@/components/SchoolOrderLink";

const inp = "rounded-xl border border-amber-900/20 bg-cream px-3 py-2 text-sm outline-none focus:border-amber-deep";

export default function MyChildren() {
  const [kids, setKids] = useState(null);
  const [edit, setEdit] = useState(null);
  const [school, setSchool] = useState(null);

  const load = () => api.get("/customer/children").then(({ data }) => { setKids(data.children); setSchool(data.school); }).catch(() => setKids([]));
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!edit.first.trim() || !edit.last.trim() || !edit.class.trim()) return toast.error("Prénom, nom et classe sont obligatoires");
    try { await api.put(`/customer/children/${edit.id}`, { first: edit.first, last: edit.last, klass: edit.class }); toast.success("Enfant mis à jour"); setEdit(null); load(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };

  const remove = async (c) => {
    if (!window.confirm(`Retirer ${c.first} ${c.last} de vos enfants enregistrés ?`)) return;
    try { await api.delete(`/customer/children/${c.id}`); toast.success("Enfant retiré"); load(); }
    catch { toast.error("Suppression impossible"); }
  };

  if (!kids || kids.length === 0) return null;

  return (
    <div data-testid="my-children" className="rounded-[1.5rem] border border-amber-800/15 bg-white p-6 shadow-sm sm:p-8">
      <p className="font-serif text-2xl font-semibold text-bark">Mes enfants</p>
      <div className="mt-1 flex flex-wrap items-center justify-between gap-3">
        <p className="text-sm text-bark-soft">Pré-remplis automatiquement lors de vos commandes école.</p>
        {school && <SchoolOrderButton school={school} testid="children-school-order-link" />}
      </div>
      <ul className="mt-4 divide-y divide-amber-900/10">
        {kids.map((c) => (
          <li key={c.id} data-testid={`child-row-${c.id}`} className="flex flex-wrap items-center justify-between gap-3 py-3">
            {edit?.id === c.id ? (
              <div className="flex flex-1 flex-wrap items-center gap-2">
                <input data-testid={`child-edit-first-${c.id}`} value={edit.first} onChange={(e) => setEdit({ ...edit, first: e.target.value })} placeholder="Prénom" className={`${inp} w-32`} />
                <input data-testid={`child-edit-last-${c.id}`} value={edit.last} onChange={(e) => setEdit({ ...edit, last: e.target.value })} placeholder="Nom" className={`${inp} w-32`} />
                <input data-testid={`child-edit-class-${c.id}`} value={edit.class} onChange={(e) => setEdit({ ...edit, class: e.target.value })} placeholder="Classe" className={`${inp} w-24`} />
                <button data-testid={`child-save-${c.id}`} onClick={save} aria-label="Enregistrer" className="flex h-9 w-9 items-center justify-center rounded-full bg-sage text-white hover:bg-sage/90"><Check size={16} /></button>
                <button data-testid={`child-cancel-${c.id}`} onClick={() => setEdit(null)} aria-label="Annuler" className="flex h-9 w-9 items-center justify-center rounded-full border border-amber-800/20 text-bark-soft"><X size={16} /></button>
              </div>
            ) : (
              <>
                <p className="flex items-center gap-2 text-bark"><UserRound size={16} className="text-amber-deep" /><strong>{c.first} {c.last}</strong><span className="text-sm text-bark-soft">· {c.class}</span></p>
                <div className="flex gap-2">
                  <button data-testid={`child-edit-${c.id}`} onClick={() => setEdit({ ...c })} className="flex items-center gap-1.5 rounded-full border border-amber-800/25 px-3 py-1.5 text-xs font-medium text-bark hover:border-amber-deep hover:text-amber-deep"><Pencil size={13} /> Corriger</button>
                  <button data-testid={`child-delete-${c.id}`} onClick={() => remove(c)} className="flex items-center gap-1.5 rounded-full border border-terra/30 px-3 py-1.5 text-xs font-medium text-terra hover:bg-terra/10"><Trash2 size={13} /> Supprimer</button>
                </div>
              </>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
